import posthog from 'posthog-js';

export function trackCourseViewed(courseDetails) {
    posthog.capture("course_viewed", {
        ...courseDetails
    });
}


export function trackCourseStarted(courseDetails) {
    posthog.capture("course_started", {
        ...courseDetails
    });
}


export function trackCourseCompleted(courseDetails) {
    posthog.capture("course_completed", {
        ...courseDetails
    });
}

export function trackCertificateDownloaded(courseDetails) {
    posthog.capture("certificate_downloaded", {
        ...courseDetails
    });
}

export function trackTimeSpent(pageDetails) {
    posthog.capture("page_time_spent", {
        ...pageDetails
    });
}